import type { Product } from '@ztechapps/common.contract'
import type { Dispatch, SetStateAction } from 'react'
import React, { useContext as useContextCore, useState } from 'react'
import { defaultComponent, type BuildOfMaterialsComponent } from './components'
import { truncate } from '@ztechapps/common.utils'

export type BillOfMaterialsProviderProps = {
  product: Product
  children: React.ReactNode
  components?: BuildOfMaterialsComponent
  canEdit: boolean
  rowHighlight?: boolean
  showInventoryFields?: boolean
}

export type BillOfMaterialsContext = {
  showAddComponent: boolean
  setShowAddComponent: Dispatch<SetStateAction<boolean>>
  truncatedProductName: string
} & Omit<BillOfMaterialsProviderProps, 'children'>

const context = React.createContext<BillOfMaterialsContext>({} as BillOfMaterialsContext)
const CoreProvider = context.Provider

export const BillOfMaterialsProvider = ({ children, components, product, ...props }: BillOfMaterialsProviderProps) => {
  const [showAddComponent, setShowAddComponent] = useState(false)

  const truncatedProductName = truncate(product?.code, 35)
  const newComponents = {
    ...defaultComponent,
    ...components,
  }

  return (
    <CoreProvider
      value={{
        showAddComponent,
        setShowAddComponent,
        product,
        truncatedProductName,
        components: newComponents,
        ...props,
      }}
    >
      {children}
    </CoreProvider>
  )
}

export const useBillOfMaterialsContext = () => useContextCore(context)
